import { SVGProps, Ref, forwardRef } from 'react';

export const IbsGrayscaleSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M22 0H2a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2" fill="#919191" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.146 10.413h.512v3.174h-.512v1.468h3.316v-1.468h-.513v-3.174h.513V8.945H4.146zm9.12 1.464a1.42 1.42 0 0 0 .829-1.394c0-.79-.614-1.532-1.677-1.532H8.076v1.468h.513v3.168h-.513v1.467h4.637a1.69 1.69 0 0 0 1.581-1.716 1.53 1.53 0 0 0-1.034-1.436zm-1.655 1.719h-.921v-.92h.92a.467.467 0 0 1 .461.46.45.45 0 0 1-.286.424.5.5 0 0 1-.177.033zm-.925-2.307v-.876h.885a.446.446 0 0 1 .433.438.453.453 0 0 1-.44.44zm6.116-.13c.082.082.192.13.308.133l1.268-.003a1.885 1.885 0 0 1 1.763 1.141c.098.228.148.473.15.722a1.912 1.912 0 0 1-1.907 1.903h-3.467v-1.9h1.904v.45h.921a.46.46 0 0 0 .326-.785.46.46 0 0 0-.326-.134h-1.25a1.85 1.85 0 0 1-1.749-1.123 1.8 1.8 0 0 1-.145-.715c0-1.195.933-1.897 2.122-1.897h3.156v1.89h-1.888v-.428h-.878a.443.443 0 0 0-.44.438.45.45 0 0 0 .132.308"
                fill="white"
            />
        </g>
    </svg>
));
IbsGrayscaleSize24Glyph.displayName = 'IbsGrayscaleSize24Glyph';
